import {useLocation, useNavigate} from "react-router-dom";
import {useEffect} from "react";
import {toast} from "react-toastify";
import {fetchAllowedRedirects, fetchMobileLongUrlByUuid} from "../api/authApi";
import LoadingSpinner from "./LoadingSpinner";

const ShortenLinkCallback = () => {
    const { search } = useLocation();
    const navigate = useNavigate();

    const params = new URLSearchParams(search);
    const redirectUrl = params.get("uuid");

    useEffect(() => {
        (async () => {
            try {
                if (!redirectUrl) {
                    toast.error("Redirect URL not found", {
                        autoClose: 5000,
                        containerId: "Main",
                    });
                    return navigate("/login", { replace: true });
                }
                const uuid = redirectUrl;
                const longRedirectUrl = await fetchMobileLongUrlByUuid(uuid)

                if (longRedirectUrl !== "") {
                    // const longRedirectUrl = await fetchAllowedRedirects();
                    window.location.href = longRedirectUrl;
                } else {
                    toast.error("Invalid Redirect URL", {
                        autoClose: 5000,
                        containerId: "Main",
                    });
                    return navigate("/login", { replace: true });
                }

            } catch (e) {

                toast.error("Error occured", {
                    autoClose: 5000,
                    containerId: "Main",
                });
                return navigate("/login", { replace: true });
            }
        })();
    }, [redirectUrl, navigate]);

    return (
        <div
            style={{
                height: "100%",
                width: "100%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                flexDirection: "column",
            }}
        >
            <LoadingSpinner />
            <h4>Redirecting to Mobile app</h4>
        </div>
    );
}
export default ShortenLinkCallback;
